import { registerTourProduct } from '../onboardingTourFactory';

/**
 * The tour of the "Platform Usage" page.
 *
 * @param {Function} t The function to perform translations with (see `getTranslateFunction()`).
 * @return {object} {steps: [...], novusPagePath: string|false }
 */
const createTour = (t) => {
  return {
    novusPagePath: 'platform-usage',
    steps: [
      {
        element: '.onboarding-tour.filter-type-platform.filter-by-date',
        novusTrackingId: 'platform-usage-filter-by-date',
        position: 'left',
        intro: t(
          'Want to see how much traffic you got over the last few weeks? Use the date filter to select the last 30 days.'
        )
      },
      {
        element: '.onboarding-tour.traffic-report-chart',
        novusTrackingId: 'platform-usage-traffic-chart',
        intro: t(
          'Wonderful! You can hover over the graph to see more information. If you see "No Data" don\'t worry - check back soon to view the user activity on the Platform.'
        )
      },
      {
        element: '.onboarding-tour.page-views-table',
        novusTrackingId: 'platform-usage-page-views-table',
        position: 'left',
        intro: t(
          'Seeing the most popular pages is easy! You can view which topics, articles, tools, and services your members are engaging with most.'
        )
      }
    ]
  };
};

export const tourName = 'platformUsageTour';
registerTourProduct(tourName, createTour);



// WEBPACK FOOTER //
// ./src/actions/onboarding/config/platformUsageTour.js